export default __webpack_public_path__ + "static/media/react-gif.6cb55ee6.png";